import React from 'react'
import { withRouter } from 'react-router-dom'
import auth from './auth'

const protect = (Component) => {

  class ProtectedComponent extends React.Component {
    componentWillMount() {
      this.checkAuthentication(this.props)
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.location !== this.props.location) {
        this.checkAuthentication(nextProps)
      }
    }

    checkAuthentication(params) {
      const { history } = params
      if (!auth.loggedIn()) {
        history.replace('/logout')
      }
    }

    render() {
      return <Component {...this.props} />
    }
  }

  return withRouter(ProtectedComponent)

}

export default protect



// WEBPACK FOOTER //
// ./src/lib/protect.js